<template>
  <div>
    <v-select
      v-model="selectVerticalCategory"
      :items="items"
      @change="setSelectCasinoVerticalCategory"
      item-text="text"
      item-value="value"
      :label="$t('filterByVerticalCategory')"
      :menu-props="{ bottom: true, offsetY: true }"
      prepend-icon="mdi-poker-chip"
      dense
      hide-details
      solo-inverted
      clearable
    ></v-select>
  </div>
</template>
<script>
export default {
  name: "select-casino-type",
  data: () => ({
    selectVerticalCategory: [],
  }),
  computed: {
    items() {
      return [
        {
          text: "Slots",
          value: "slots",
        },
        {
          text: "Card",
          value: "card",
        },
        {
          text: "Roulette",
          value: "roulette",
        },
        {
          text: "Casual",
          value: "casual",
        },
        {
          text: "Virtual sp",
          value: "virtual_sp",
        },
        {
          text: "Lottery",
          value: "lottery",
        },
        {
          text: "Crash",
          value: "crash",
        },
        {
          text: "Poker",
          value: "poker",
        },
        {
          text: "Food",
          value: "food",
        },
        {
          text: "Video poke",
          value: "video_poke",
        },
        {
          text: "Craps",
          value: "craps",
        },
        {
          text: "Fishing",
          value: "fishing",
        },
      ];
    },
  },

  methods: {
    setSelectCasinoVerticalCategory(value) {
      this.items.map((item, index) => {
        if (item.value == value) {
          this.toggleValue = index;
        }
      });

      // tratamento clearable
      if (value == undefined) {
        this.$store.commit("setSelectCasinoVerticalCategory", "");
      } else {
        this.$store.commit("setSelectCasinoVerticalCategory", value);
      }
    },
  },
};
</script>